import { HTRequestItem, HTRequestType } from "../../../api/entities";
import React, { Component } from "react";
import ListDataView from "@my-dld/components/DataView/ListDataView";
import CardNoData from "@my-dld/components/CardNoData";
import Strings from "@my-dld/assets/strings";
import { getLocalValue } from "@eres/core/dist/LocaleValue";
import { DateUtil, I8N, LocaleUtil } from "@eres/core";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";

export interface RequestsProps {
	requests: HTRequestItem[];
	onDetails: ( request: HTRequestItem ) => void;
}

class RequestsListView extends Component<RequestsProps> {
	componentDidMount(): void {
		this.configDataTable();
	}

	render() {
		const { requests, onDetails } = this.props;
		return <React.Fragment>
			<ListDataView
				items={ requests }
				renderListHeader={ () => <RenderHeader/> }
				renderListItem={ ( item: HTRequestItem, index: number ) => {
					return <RenderListItem
						key={ `ht_req_list${ index }` }
						request={ item }
						onDetails={ onDetails }/>;
				} }/>
			{ requests.length === 0 && <CardNoData containerClass="alert alert-warning"/> }
		</React.Fragment>;
	}

	private configDataTable = () => {
		try {
			window.$( "#ListView" ).DataTable( {
				//language: LocaleUtil.Select( DataTableLang ),
                language: { url: "https://cdn.datatables.net/plug-ins/1.10.20/i18n/" + (I8N.current == "ar" ? "Arabic.json" : "English.json"), lengthMenu: '_MENU_' },
                dom: "<'table-responsive'rt>" + "<'dt-cfooter'i<'dt-fpl'pl>>",
                pagingType: "simple_numbers",
				responsive: false,
				lengthChange: false,
				scrollX: true
			} );
			const onDetails = this.props.onDetails;
			window.$( "#ListView" ).on( "click", "a", function () {
				// @ts-ignore
				const request = JSON.parse( this.getAttribute( "data-item" ) );
				if ( request )
					onDetails( request );
				return false;
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	};
}

function RenderHeader() {
	return <tr>
		<th>{ Strings.request_type }</th>
		<th>{ Strings.request_number }</th>
		<th>{ Strings.request_date }</th>
		<th>{ Strings.property_info }</th>
		<th>{ Strings.request_status }</th>
		<th>{ " " }</th>
	</tr>;
}

function RenderListItem( props: { request: HTRequestItem, onDetails: ( request: HTRequestItem ) => void } ) {
	const { request, onDetails } = props;
	return <tr>
		<td data-label={ Strings.request_type }>{ getReqType( request ) }</td>
		<td data-label={ Strings.request_number }>{ request.RequestNumber }</td>
		<td data-label={ Strings.request_date } dir={ "ltr" }>{ getReqDate( request ) }</td>
		<td data-label={ Strings.property_info }>{ getReqPropertyInfo( request ) }</td>
		<td data-label={ Strings.request_status }>{ getReqStatus( request ) }</td>
		<td data-label="Action" className="text-start">
			<a
				href="#" className="btn underline p-0 font-size14"
				data-item={ JSON.stringify( request ) }>
				{ Strings.view_details }
			</a>
		</td>
	</tr>;
}

export function getReqType( request: HTRequestItem ) {
	return request.RequestTypeId === HTRequestType.HANDOVER ? Strings.ejari_handover : Strings.ejari_takeover;
}

export function getReqDate( request: HTRequestItem ) {
	return request.RequestedOn ? DateUtil.formatDate( request.RequestedOn.asDate(), "DD/MM/YYYY hh:mm A", "en" ) : "-";
}

export function getReqPropertyInfo( request: HTRequestItem ) {
	const area = getLocalValue( { en: request.AreaNameEn, ar: request.AreaNameAr } );
	return `${ request.PropertyNumber }, ${ area }`;
}

export function getReqStatus( request: HTRequestItem ) {
	return getLocalValue( { en: request.RequestStatusNameEn, ar: request.RequestStatusNameAr } );
}

export default RequestsListView;
